import { FC } from "react";
import { IOrder } from "../../../model/IOrder";
import { DetailPanel, DetailRow } from "./DetailPanel";

const OrderShipping: FC<{ order: IOrder }> = ({ order }) => (
  <DetailPanel title="Shipping Info">
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-x-8">
      <div>
        <DetailRow label="Delivery Option" value={order.siType} boxed />
        <DetailRow label="Name" value={order.siName} boxed />
        <DetailRow label="Company" value={order.siCompany} boxed />
        <DetailRow label="Liftgate" value={order.liftgate} />
      </div>

      <div>
        <DetailRow label="Primary Phone" value={order.siPhone} boxed />
        <DetailRow label="Secondary Phone" value={order.siSecondaryPhone} boxed />
        <DetailRow label="EMail" value={order.siEmail} boxed />
        <DetailRow label="Fax" value={order.siFax} boxed />
      </div>

      <div>
        <DetailRow label="Street Address" value={order.siStreet} boxed />
        <DetailRow
          label="City, State, ZIP"
          value={[order.siCity, order.siState, order.siZip].filter(Boolean).join(', ')}
          boxed
        />
        <DetailRow label="Country" value={order.siCountry} boxed />
        <DetailRow label="Carrier" value={order.siCarrier} />
        <DetailRow label="Tracking Number" value={order.siTrackingNum} />
      </div>
    </div>
  </DetailPanel>
);

export default OrderShipping;
